import { connect } from 'react-redux';
import ModalAppContainer from './ModalAppContainer';

const mapStateToProps = ({
  modalReducer
}) => ({
  modalReducer
});

const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalAppContainer);
